var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.genderTypeClass},[_c('PercentBar',{staticClass:"percentBox__percentBar",attrs:{"percent":_vm.gender.score,"type":_vm.gender.sliderType,"genderType":_vm.genderType}}),_vm._v(" "),_c('p',{staticClass:"endPercent"},[_vm._v("100%")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }